import {GET_ROBOTS_AND_VEHICLES_STARTED} from "../../../reducers/robotsAndVehiclesReducer";


export const getRobotsStarted = () =>{
    return {
        type: GET_ROBOTS_AND_VEHICLES_STARTED,
        payload: {}
    }
}